export default __webpack_public_path__ + "static/media/golang.f2a31e5e.svg";